import {
  Box,
  Grid,
  Stack,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import Dialog from "@mui/material/Dialog";
import { BiMinusCircle } from "react-icons/bi";
import DialogTitle from "@mui/material/DialogTitle";
import { useMutation, useQuery } from "@apollo/client";
import DialogContent from "@mui/material/DialogContent";
import { AuthContext } from "../../Context/AuthContext";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import React, { useContext, useState, useEffect } from "react";
import {
  GET_REQUEST_TRANSACTION_BY_ENROLLMENT_ID,
  UPDATE_REQUEST_TRANSACTION,
} from "../../Schema/Enrollment";

export default function AllowClassStudent({ studentId, editData }) {
  const { setAlert } = useContext(AuthContext);
  const [noLoading, setNoLoading] = useState(false);
  const [yesLoading, setYesLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { refetch, data } = useQuery(GET_REQUEST_TRANSACTION_BY_ENROLLMENT_ID, {
    variables: {
      enrollmentId: editData?._id,
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  const [updateRequestTransaction] = useMutation(UPDATE_REQUEST_TRANSACTION, {
    onCompleted: ({ updateRequestTransaction }) => {
      setYesLoading(false);
      setNoLoading(false);
      if (updateRequestTransaction?.status) {
        setAlert(true, "success", updateRequestTransaction?.message);
        handleClose();
        refetch();
      } else {
        setAlert(true, "error", updateRequestTransaction?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const hanldeRequestTransaction = (status) => {
    if (status) {
      setYesLoading(true);
    } else {
      setNoLoading(true);
    }

    updateRequestTransaction({
      variables: {
        id: data?.getRequestTransactionByEnrollmentId?._id,
        input: {
          studentId: studentId,
          financeStatus: status,
          enrollmentId: editData?._id,
        },
      },
    });
  };

  // console.log("data?.getRequestTransactionByEnrollmentId ==>", data?.getRequestTransactionByEnrollmentId);

  return (
    <>
      {data?.getRequestTransactionByEnrollmentId?.teacherStatus === true &&
        data?.getRequestTransactionByEnrollmentId?.financeStatus === null && (
          <Button
            sx={{
              fontSize: 12,
              color: "red",
              paddingX: 1.5,
              whiteSpace: "pre",
              bgcolor: "#FFEDED !important",
              marginRight: "-10px !important",
            }}
            onClick={handleOpen}
            startIcon={<AutorenewIcon />}
          >
            request not allow
          </Button>
        )}

      <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
        <DialogTitle sx={{ padding: "10px 20px" }}>
          <Stack direction="row" spacing={2}>
            <Stack direction="column" justifyContent="center">
              <Typography className="dialog-title">
                Not Allow Student To Class
              </Typography>
            </Stack>

            <Box sx={{ flexGrow: 1 }} />
            <Stack direction="column" justifyContent="center">
              <IconButton onClick={handleClose}>
                <BiMinusCircle className="close-icon" />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container rowSpacing={2} columnSpacing={4}>
            <Grid item xs={12}>
              <Typography>
                Do you want to not allow student to class?
              </Typography>
            </Grid>

            <Grid item xs={6}>
              {yesLoading ? (
                <Button
                  className="btn-create"
                  fullWidth
                  sx={{ color: "white" }}
                >
                  Loading...
                </Button>
              ) : (
                <Button
                  className="btn-create"
                  fullWidth
                  onClick={() => hanldeRequestTransaction(true)}
                >
                  YES
                </Button>
              )}
            </Grid>

            <Grid item xs={6}>
              {noLoading ? (
                <Button className="btn-delete" fullWidth>
                  Loading...
                </Button>
              ) : (
                <Button
                  className="btn-delete"
                  fullWidth
                  onClick={() => hanldeRequestTransaction(false)}
                >
                  Not
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
